import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'stripHTMLTags'})
export class StripHTMLTagsPipe implements PipeTransform {

	/**
	 * Remove HTML tags from string
	 * @param value string
	 */
	transform(value: string): string {
		// convert <br/> tags to line breaks
		value = value.replace(/<br ?\/?>/g, '\n').replace(/<[^>]*>/g, '');
		// strip double line breaks
		return value.replace(/\n\s*\n/g, '\n');
	}
}
